"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const actionNames = __importStar(require("../constants/actions"));
const getDiscovery = (options = {}) => __awaiter(void 0, void 0, void 0, function* () {
    if (!options.discovery) {
        throw new Error('Get discovery requires a discovery url');
    }
    let parent;
    if (options.platform === 'web') {
        parent =
            global.parent !== global.window && global.document.referrer
                ? new URL(global.document.referrer).hostname
                : global.document.location.hostname;
    }
    const { data } = yield axios_1.default.post(options.discovery, Object.assign({ env: options.environment, host: options.host, lang: options.lang, platform: options.platform, appVersion: options.appVersion, commitSha: options.commitSha, pullRequest: options.pullRequest, branch: options.branch }, (parent && { parent })));
    return Object.assign(Object.assign({}, data), { services: {
            identity: data.services.iam,
            api: data.services.api,
        } });
});
const setup = ({ auth, next, serviceCache, options }) => () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (serviceCache.setup) {
            yield serviceCache.setup();
        }
        if ((options === null || options === void 0 ? void 0 : options.discovery) || (options === null || options === void 0 ? void 0 : options.discoverMock)) {
            const discoveryResponse = (options === null || options === void 0 ? void 0 : options.discoverMock) ? options.discoverMock
                : yield getDiscovery(options);
            next({
                type: actionNames.API_DISCOVERY_RESULT,
                payload: Object.assign({}, discoveryResponse),
            });
            yield serviceCache.set(discoveryResponse.services);
        }
    }
    catch (err) {
        console.warn('Could not update service cache', err);
    }
    finally {
        auth.setAuthDomain(yield serviceCache.getUrl('identity'));
    }
});
exports.default = setup;
